<script lang="ts">
    import Vue from "vue";
    import Component from 'vue-class-component';
    import { ProjectUserDeleterViewModel } from '@ProjectUsers/Components/ProjectUserDeleter';

    @Component({
        props: {
            viewModel: {
                type: Object,
                required: true
            }
        }
    })
    export default class ProjectUserDeleter extends Vue
    {
        get vm(): ProjectUserDeleterViewModel { return this.$props.viewModel as ProjectUserDeleterViewModel; }
        get opened(): boolean { return this.vm?.opened ?? false; }

        get projectUserId(): number { return this.vm.projectUserId; }
        get projectUserName(): string { return this.vm.projectUserName; }
        get initialized(): boolean { return this.vm.deps != null; }

        get hasDependants(): boolean { return this.vm.deps?.HasDependants; }        
        get dependenciesCount(): number { return this.vm.deps?.DependenciesCount; }
        get estimationsSurveys() { return this.vm.deps?.EstimationsSurveys; }
        get criteriaSurveys() { return this.vm.deps?.CriteriaSurveys; }
        get scoringSurveys() { return this.vm.deps?.ScoringSurveys; }

        deleteProjectUser()
        {
            this.$emit("delete-project-user", this.projectUserId);
        }

        archiveProjectUser()
        {
            this.$emit("archive-project-user", this.projectUserId);
        }

        close()
        {
            this.vm.close();
        }
    }
</script>

<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div v-if="!initialized" class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Delete user</h5>
                        <button type="button" class="close" @click="close">&times;</button>
                    </div>
                    <div class="modal-body">
                        <h4><i class="fa fa-spinner fa-spin"></i> Checking dependencies...</h4>
                    </div>
                    <div class="modal-footer">
                        <button type="button" @click="close" class="btn btn-outline-secondary">Cancel</button>
                    </div>
                </div>
            </div>

            <div v-if="initialized && hasDependants" class="modal-dialog modal-lg modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Delete user</h5>
                        <button type="button" class="close" @click="close">&times;</button>
                    </div>

                    <div class="modal-body">
                        <div class="alert alert-danger text-dark" role="alert">
                            <h5 class="alert-heading">Cannot delete this user</h5>
                            <p>
                                The user '<strong>{{projectUserName}}</strong>' is in <strong>{{dependenciesCount}}</strong> places.
                                To Delete them & their votes please first remove them from the following Panels.
                                Alternatively, consider Archiving this user, to keep their previous votes, but stop them being selected for any new panels.
                            </p>
                        </div>
                        <div>
                            <div class="card" v-if="criteriaSurveys.length > 0">
                                <div class="card-header">
                                    Criteria panels (<span>{{criteriaSurveys.length}}</span>)
                                </div>
                                <ul class="list-group list-group-flush">
                                    <li class="list-group-item" v-for="s in criteriaSurveys" :key="s.Id ">
                                        <a class="text-primary" target="_blank" v-sanitizedHref="s.Url">{{s.Name}}</a>
                                    </li>
                                </ul>
                            </div>

                            <div class="card mt-2" v-if="estimationsSurveys.length > 0">
                                <div class="card-header">
                                    Assessments panels (<span>{{estimationsSurveys.length}}</span>)
                                </div>
                                <ul class="list-group list-group-flush">
                                    <li class="list-group-item" v-for="s in estimationsSurveys" :key="s.Id ">
                                        <a class="text-primary" target="_blank" v-sanitizedHref="s.Url">{{s.Name}}</a>
                                    </li>
                                </ul>
                            </div>

                            <div class="card mt-2" v-if="scoringSurveys.length > 0">
                                <div class="card-header">
                                    Scoring panels (<span>{{scoringSurveys.length}}</span>)
                                </div>
                                <ul class="list-group list-group-flush">
                                    <li class="list-group-item" v-for="s in scoringSurveys" :key="s.Id ">
                                        <a class="text-primary" target="_blank" v-sanitizedHref="s.Url">{{s.Name}}</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <button type="button" @click="archiveProjectUser" class="btn btn-primary">Archive</button>
                        <button type="button" @click="close" class="btn btn-outline-secondary">Cancel</button>
                    </div>
                </div>
            </div>

            <div v-if="initialized && !hasDependants" class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header bg-danger text-white">
                        <h5 class="modal-title">Delete user</h5>
                        <button type="button" class="close text-white" @click="close">&times;</button>
                    </div>

                    <div class="modal-body">
                        <h4>Are you sure you want to delete this user?</h4>
                        <p>You are about to delete '<strong>{{projectUserName}}</strong>'. This can't be undone.</p>
                    </div>

                    <div class="modal-footer">
                        <button type="button" @click="deleteProjectUser" class="btn btn-danger">Delete</button>
                        <button type="button" @click="close" class="btn btn-outline-secondary">Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
</style>